import { useContext } from "react";
import AuthContext from "../context/AuthProvider";

const useFilterData = () => {
    return useContext(AuthContext);
}

export default useFilterData;